// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Caml from "../../../../../node_modules/rescript/lib/es6/caml.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../../utils/CSS.bs.js";
import * as ScrollY$Showside from "../../utils/ScrollY.bs.js";
import * as Settings$Showside from "../../types/Settings.bs.js";
import * as ResizeObserver$Showside from "../../utils/ResizeObserver.bs.js";
import * as ViewportContext$Showside from "../../context/ViewportContext.bs.js";
import * as NavMenu__Context$Showside from "./NavMenu__Context.bs.js";
import * as EntrypointContext$Showside from "../../context/EntrypointContext.bs.js";
import * as NavMenu__Backdrop$Showside from "./NavMenu__Backdrop.bs.js";
import * as UseDelayedBoolean$Showside from "../../hook/UseDelayedBoolean.bs.js";
import * as RefByQuerySelector$Showside from "../../utils/RefByQuerySelector.bs.js";
import * as NavMenu__ModalLayout$Showside from "./NavMenu__ModalLayout.bs.js";
import * as ConfigurationProvider$Showside from "../../context/ConfigurationProvider.bs.js";
import * as StickyHeaderOffsetProvider$Showside from "../../context/StickyHeaderOffsetProvider.bs.js";
function usePositions(activeValue, param) {
  var ctx = NavMenu__Context$Showside.use(undefined);
  var match = ConfigurationProvider$Showside.use(undefined);
  var match$1 = match.config;
  var match$2 = ViewportContext$Showside.use(undefined);
  var windowHeight = match$2.windowSize.height;
  ScrollY$Showside.useWindow(undefined, undefined) | 0;
  var match$3 = StickyHeaderOffsetProvider$Showside.use(undefined);
  var siteHeaderCSSSelector = Settings$Showside.getSiteHeaderCSSSelector(match$1.settings, match$1.transitiveAccount);
  var siteHeaderRef = RefByQuerySelector$Showside.use(undefined, siteHeaderCSSSelector);
  var siteHeaderSize = ResizeObserver$Showside.useResizeObserver(undefined, siteHeaderRef);
  var embedSize = ResizeObserver$Showside.useResizeObserver(undefined, match$3.containerRef);
  var siteHeaderSize$1 = Belt_Option.getWithDefault(Belt_Option.orElse(siteHeaderSize, embedSize), ResizeObserver$Showside.empty);
  var match$4 = ctx.mode;
  var modalTop = match$4 ? 0 : Caml.int_max(0, siteHeaderSize$1.height + siteHeaderSize$1.top | 0);
  var modalBackdropHeight = windowHeight > 768 ? ctx.modalBackdropHeight : ctx.modalBackdropHeight / 2 | 0;
  var match$5 = ctx.mode;
  var modalMaxHeight = match$5 ? windowHeight : Caml.int_min(windowHeight - modalBackdropHeight | 0, windowHeight - ((siteHeaderSize$1.height + siteHeaderSize$1.top | 0) + modalBackdropHeight | 0) | 0);
  return {
    modalTop: modalTop,
    modalMaxHeight: modalMaxHeight,
    siteHeaderSize: siteHeaderSize$1
  };
}
function useOpenTracker(param) {
  var ctx = NavMenu__Context$Showside.use(undefined);
  var match = EntrypointContext$Showside.use(undefined);
  var trackEvent = match.trackEvent;
  var openEventTriggered = React.useRef(false);
  React.useEffect(function () {
    var match = ctx.isModalOpen;
    var match$1 = openEventTriggered.current;
    if (match && !match$1) {
      Curry.app(trackEvent, ["open", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
      Curry.app(trackEvent, ["menu:open", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
      openEventTriggered.current = true;
    }
  }, [ctx.isModalOpen]);
}
function NavMenu__ModalContainer(Props) {
  var activeValue = Props.activeValue;
  var children = Props.children;
  var onMouseLeave = Props.onMouseLeave;
  var onMouseEnter = Props.onMouseEnter;
  var ctx = NavMenu__Context$Showside.use(undefined);
  var viewport = ViewportContext$Showside.use(undefined);
  ConfigurationProvider$Showside.use(undefined);
  var mounted = UseDelayedBoolean$Showside.useDelayedBoolean(ctx.modalTransitionSpeedMs, /* DelayFalse */1, ctx.isModalOpen);
  var positions = usePositions(activeValue, undefined);
  useOpenTracker(undefined);
  var renderHorizontalBorder = function (param) {
    return React.createElement(React.Fragment, undefined, React.createElement("div", {
      className: CSS$Showside.prefix("absolute pointer-events-none z-20 left-0 w-full border-t border-primary opacity-10")
    }), React.createElement("div", {
      className: CSS$Showside.prefix("absolute pointer-events-none bottom-0 left-0 w-full border-b border-primary opacity-10")
    }));
  };
  var match = ctx.mode;
  var updatedViewport = match ? {
    isMobile: viewport.isMobile,
    breakpoint: viewport.breakpoint,
    windowSize: {
      width: Math.min(ctx.modalMaxWidth, viewport.windowSize.width),
      height: viewport.windowSize.height
    }
  } : viewport;
  var match$1 = ctx.mode;
  var match$2 = ctx.mode;
  var match$3 = ctx.mode;
  var tmp = {
    className: CSS$Showside.prefix(Cn.make([mounted ? "" : "hidden", "fixed", "transition animate-enter-scaleup motion-reduce:animate-enter-fadein", "left-0 w-full", "transform motion-reduce:transform-none", ctx.isModalOpen ? "scale-100 opacity-100 ease-linear-out-slow-in" : "scale-95 opacity-0 ease-fast-out-linear-in", "bg-main text-primary", match$1 ? "top-0 h-full" : ""])),
    style: {
      maxHeight: CSS$Showside.intToPx(positions.modalMaxHeight),
      maxWidth: match$2 ? CSS$Showside.intToPx(ctx.modalMaxWidth) : "100%",
      top: CSS$Showside.intToPx(positions.modalTop),
      zIndex: String(ctx.zIndex),
      animationDuration: CSS$Showside.intToMs(ctx.modalTransitionSpeedMs),
      transitionDuration: CSS$Showside.intToMs(ctx.modalTransitionSpeedMs),
      transformOrigin: match$3 ? "center left" : "top center",
      pointerEvents: ctx.isModalOpen ? "auto" : "none"
    }
  };
  if (onMouseEnter !== undefined) {
    tmp.onMouseEnter = Caml_option.valFromOption(onMouseEnter);
  }
  if (onMouseLeave !== undefined) {
    tmp.onMouseLeave = Caml_option.valFromOption(onMouseLeave);
  }
  return React.createElement(NavMenu__Context$Showside.Provider.make, {
    value: {
      mode: ctx.mode,
      currentFullPath: ctx.currentFullPath,
      currentL1: ctx.currentL1,
      currentL2: ctx.currentL2,
      currentL3: ctx.currentL3,
      pageFlipTransitionSpeedMs: ctx.pageFlipTransitionSpeedMs,
      modalTransitionSpeedMs: ctx.modalTransitionSpeedMs,
      modalBackdropHeight: ctx.modalBackdropHeight,
      modalBackdropOpacity: ctx.modalBackdropOpacity,
      modalMaxWidth: ctx.modalMaxWidth,
      zIndex: ctx.zIndex,
      maxLevels: ctx.maxLevels,
      positions: positions,
      threeColumnLayout: ctx.threeColumnLayout,
      isModalOpen: ctx.isModalOpen,
      isIndexAllowed: ctx.isIndexAllowed
    },
    children: null
  }, React.createElement(NavMenu__Backdrop$Showside.make, {}), React.createElement("div", tmp, renderHorizontalBorder(undefined), React.createElement(ViewportContext$Showside.Provider.make, {
    value: updatedViewport,
    children: React.createElement(NavMenu__ModalLayout$Showside.make, {
      children: children
    })
  })));
}
NavMenu__ModalContainer.displayName = "NavMenu__ModalContainer";
var make = NavMenu__ModalContainer;
export { usePositions, useOpenTracker, make };
/* react Not a pure module */